export default "__VITE_ASSET__912a6f52__"